import { AbstractAdapter } from '@shared/helpers/abstract.adapter';
import { Injectable } from '@angular/core';
export class BlogPage {
  isEmpty: boolean;
  isFirst: boolean;
  isLast: boolean;
  pageNumber: number;
  numberOfElements: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  indexes: number[];
}

@Injectable({
  providedIn: 'root'
})
export class BlogPageAdapter extends AbstractAdapter {
  private mapper = {
    isEmpty: {
      alternativeKeyName: 'empty'
    },
    isFirst: {
      alternativeKeyName: 'first'
    },
    isLast: {
      alternativeKeyName: 'last'
    },
    pageNumber: {
      alternativeKeyName: 'number'
    },
    numberOfElements: {},
    pageSize: {
      alternativeKeyName: 'size'
    },
    totalElements: {},
    totalPages: {},
    indexes: [],
  };
  constructor() {
    super();
  }

  adapt(item: any, mapper?: unknown): BlogPage {
    const pageInfo = new BlogPage();
    const adaptMapper = (typeof mapper === 'object') ? mapper : this.mapper;
    super.processMapping(adaptMapper, item, pageInfo);
    pageInfo['indexes'] = Array.from({ length: pageInfo.totalPages }, (_, i) => i + 1);
    return pageInfo;
  }
}
